/* @flow strict */

import * as React from 'react';
import Panel from './../../components/panel';
import EditOrgModal from './modals/organization';
import { GET } from '/client/src/api';
import PreloadPanelRow from './../../components/panel/preloadPanelRow';

type PropsType = {
  context: {},
  isModalOpenByDefault: boolean
};

const SettingsPageOrg = ({ context, isModalOpenByDefault = false }: PropsType): React.Element<typeof React.Fragment> => {
  const [isOpen, handleToggleModal] = React.useState(false);
  const [orgData, setOrgData] = React.useState(null);
  const [isPending, setPending] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
    handleToggleModal(isModalOpenByDefault);
    }, 500);
  }, [isModalOpenByDefault]);

  const getOrgData = React.useCallback(async () => {
    try {
      setPending(true);
      const { result } = await GET('/api/v1/1/merchants/organization_info_app');

      setOrgData(result);
      setPending(false);
    } catch (e) {
      setPending(false);
    }
  }, []);

  if (!isPending && !orgData) {
    getOrgData();
  }

  const forceGetData = () => {
    getOrgData();
  };


  // Ticket sold => Purch
  // Amount => Payout
  // Views =>  Put ticket sold today number unless chart
  const { x1, x2, y1, y2 } = _.get(orgData, 'logo_crop_info', {});
  const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})&width=640;`;

  return (
    <>
      <Panel
        className='SettingsPagePayment-payment'
        title={
          <div>
            Organization Information

            <span
              className='panel-title-action  btn'
              data-disabled={`${!orgData}`}
              onClick={(): any => handleToggleModal(true)}
            >Edit</span>
          </div>
        }
        headerClassName='panel-heading-green'
      >
        <div className="row">
          <div className="col-lg-6">
            <ul className='table'>
              <li>
                <span className='key'>Company name</span>
                <span className='value'>
                  {orgData ? _.get(orgData, 'company_name', '-') : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Default customer support email</span>
                <span className='value'>
                  {orgData ? _.get(orgData, 'contact_email', '-') : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Company website URL</span>
                <span className='value'>
                  {orgData ? _.get(orgData, 'website', '-') : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Bill statement descriptor</span>
                <span className='value'>
                  {orgData ? _.get(orgData, 'bill_remark', '-') : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Tax number</span>
                <span className='value'>
                  {orgData ? _.get(orgData, 'code_501_c3', '-') : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Tax label</span>
                <span className='value'>
                  {orgData ? _.get(orgData, 'tax_label', '-') : <PreloadPanelRow />}
                </span>
              </li>
              <li>
                <span className='key'>Company logo</span>
                <span className='value'>
                  {orgData ?
                    <>
                      {orgData.logo_url ?
                        <span className='companyLogo'>
                          <img src={`${orgData.logo_url}?${imageUrlParams}`} alt="Organization Logo"/>
                        </span> :
                        '-'
                      }
                    </> :
                    <PreloadPanelRow />
                  }
                </span>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      {isOpen &&
        <EditOrgModal
          isOpen={isOpen}
          getOrgData={forceGetData}
          handleToggleModal={handleToggleModal}
          data={{
            ...context.profileCurrent,
            ...orgData
          }}
        />
      }
    </>
  );
};

export default SettingsPageOrg;
